import { SimplePageModule } from "./simple_page";
export class mortgage_export extends SimplePageModule {
    getModuleName() {
        return "mortgage_export";
    }
}
